<button [matTooltip]="tooltip()" mat-menu-item class="app-button">
  <div>
    <ng-content select="[icon]"></ng-content>
  </div>
  <div class="label">
    <ng-content select="[label]"></ng-content>
  </div>
</button>
